<template lang="pug">
  div
    filter-table(
      layout="text"
      @inputSearchFilter="inputSearchFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'tariff', order: 'descending'}"
        @row-click="openDetalleMovimientos"
        )
        ods-table-column(prop='codestadoqr' label='Estado' sortable class-name="cell-tag")
          template(slot-scope="scope")
            ods-tag(:type="getType(scope.row.codestadoqr)") {{ scope.row.desestadoqr }}
        ods-table-column(prop='desrechazoqr' label='Motivo rechazo' sortable)
        ods-table-column(prop='idpan' label='Tarjeta' sortable)
        ods-table-column(prop='destpv' label='Terminal' sortable)
        ods-table-column(prop='fecha' label='Fecha')
        ods-table-column(prop='importe' label='Importe')
        ods-table-column(prop='clamoniso' label='Moneda')

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes = '[5, 10, 50, 100]',
        //- :page-size = itemsPerPage,
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

      ods-dialog(
        :visible.sync="showDetails"
        :append-to-body="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        :show-close="true"
        center
        width="820px")
        div
          detalle-movimientos(:data="rowData")
        .dialog-footer(slot='footer')
          ods-button(@click='handleDialogClose') Aceptar

</template>

<script>
import DetalleMovimientos from '@/views/DetalleMovimientos'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'MovementsTable',

  components: {
    DetalleMovimientos,
    FilterTable,
    Paginator
  },

  props: {
    // data: {
    //   required: true
    // },
    commerce: {
      required: true
    }
  },

  data () {
    return {
      defaultParams: { codcom: this.commerce.codcom },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      expandKey: [],
      // tableData: this.data,
      // itemsPerPage: 10,
      // currentPageData: 1,
      // totalData: 0,
      showDetails: false,
      rowData: {}
    }
  },

  // watch: {
  //   data (newData, oldData) {
  //     this.tableData = newData
  //     this.totalData = newData.length
  //   }
  // },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de QR - Movimientos
      await this.$store.dispatch('listMovimientos', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
          this.$emit('totalMovements', this.tableDataRendered ? this.tableDataRendered.length : 0)
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.desrechazoqr.toLowerCase().includes(text.toLowerCase()) ||
          res.idpan.toLowerCase().includes(text.toLowerCase()) ||
          res.destpv.toLowerCase().includes(text.toLowerCase())
      })
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    editMovements (numvendor) {
      this.$emit('editMovements', numvendor)
    },

    detailMovements (numvendor) {
      this.$emit('detailMovements', numvendor)
    },

    deleteMovements (numvendor) {
      this.$emit('deleteMovements', numvendor)
    },

    openDetalleMovimientos (row) {
      this.rowData = row
      this.showDetails = true
    },

    handleDialogClose () {
      this.showDetails = false
    },

    getType (row) {
      switch (row) {
        case '01':
          return 'default'
        case '02':
          return 'danger'
        case '03':
          return 'secondary'
        case '04':
          return 'success'
      }
    }
  },

  mounted () {
    this.getInitialData()
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}

/deep/ .ods-table__expanded-cell {
  padding: rem(12) rem(24)!important;
  background: #F9F9FB;
}

/deep/ .ods-table__expanded-cell:hover {
  background-color: #F9F9FB!important;
}

/deep/ .ods-table__expanded-cell:hover td {
  border-bottom: 1px solid #d1d9de;
}

.tramos {
  .title {
    text-transform: uppercase;
  }

  .ods-table {
    background: #fff;
    margin: 12px 0;
  }

  /deep/ .ods-table thead th {
    padding: 0;
  }

  /deep/ .ods-table td, .ods-table th {
    padding: 4px 0;
  }

  /deep/ .ods-table__row--striped > td {
    background: #F0F0F0!important;
  }
}
</style>
